import ApiClient from "../api/apiClient";

const ATP = "/atp";
const USERATPPROFILE = "/atp/";
const UPDATEUSERATPSTATUS = "/atp/";
const CREATEATPUSERMANUALLY = "/user/manual-atp-created";
const ATP_USERS_COUNTS = "/atp/get-atp-status-count";

const getAtpUsers = ({ page, limit, status, search, company_name, registered_from, registered_to, start_date, end_date, payment_from, payment_to, payment_status, full_name }) => {
    const baseUrl = `${ATP}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}`;

    // Add optional parameters if present
    if (status) queryParams += `&status=${status}`;
    if (company_name) queryParams += `&company_name=${company_name}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (payment_status) queryParams += `&payment_status=${payment_status}`;
    if (full_name) queryParams += `&full_name=${full_name}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getAtpUsersCounts = ({ status, search, company_name, registered_from, registered_to, start_date, end_date, payment_from, payment_to, payment_status, full_name }) => {
    const baseUrl = `${ATP_USERS_COUNTS}?`;

    let queryParams = "";

    // Add optional parameters if present
    if (status) queryParams += `&status=${status}`;
    if (company_name) queryParams += `&company_name=${company_name}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (payment_from) queryParams += `&payment_from=${payment_from}`;
    if (payment_to) queryParams += `&payment_to=${payment_to}`;
    if (search) queryParams += `&search=${search}`;
    if (payment_status) queryParams += `&payment_status=${payment_status}`;
    if (full_name) queryParams += `&full_name=${full_name}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getUserAtpProfile = ({ id }) => {
    const url = USERATPPROFILE + id;
    return ApiClient.get(url);
};

const updateUserAtpStatus = (id, data) => {
    return ApiClient.patch(UPDATEUSERATPSTATUS + id, data);
};

const createATPUserManually = (data) => {
    return ApiClient.post(CREATEATPUSERMANUALLY, data);
};

export const atpUsersService = {
    getAtpUsers,
    getUserAtpProfile,
    updateUserAtpStatus,
    createATPUserManually,
    getAtpUsersCounts,
};
